import {usePopup} from "@/utils/popup";
import FcltyChoc from "@/views/my-home/fclty-choc.vue";
import Postcode from "@/components/postcode.vue";
import SignaturePad from "@/components/signature-pad.vue";
import Lgin from "@/views/lgin/lgin.vue";

const lgin = {
  show: () => {
    const { show: popupShow } = usePopup();
    const popupOpts = {
      header: '로그인',
    }

    popupShow(Lgin, popupOpts, null, null);
  }
}

const fcltyChoc = {
  show: (chocFunc) => {
    const { show: popupShow } = usePopup();

    const popupOpts = {
      header: '시설선택',
      contentStyle: {
        'height': '500px',
        'width': '700px',
      }
    }
    const popupEmits = {
      choc: chocFunc
    }

    popupShow(FcltyChoc, popupOpts, null, popupEmits);
  }
}

const postcode = {
  show: (comptFunc) => {
    const { show: popupShow } = usePopup();

    const popupOpts = {
      header: '주소검색',
      contentStyle: {
        'width': '500px',
        'padding': '0px'
      }
    };

    const popupEmits = {'compt': comptFunc};
    popupShow(Postcode, popupOpts, null, popupEmits)
  }
}

const signaturePad = {
  show: (comptFunc) => {
    const { show: popupShow } = usePopup();

    const popupOpts = {
      header: '서명하기',
      contentStyle: {
        'width': '350px'
      }
    };

    const popupEmits = {'compt': comptFunc};

    popupShow(SignaturePad, popupOpts, null, popupEmits)
  }
}

const useCmmnPopup = () => {
  return {
    lginShow: lgin.show,
    fcltyChocShow: fcltyChoc.show,
    postcodeShow: postcode.show,
    signaturePadShow: signaturePad.show
  };
};

export {useCmmnPopup};
